import Command from '@ckeditor/ckeditor5-core/src/command';


export default class ResButtonCommand extends Command {

    execute(response) {
        const editor = this.editor;

        editor.model.change(writer => {
            // Create a <placeholder> elment with the "name" attribute...

            let name = response.name;
            let event = response.event;
            const InsertEmoji = writer.createElement('InsertEmoji',
                {name: name, event: event}
            );

            editor.model.insertContent(InsertEmoji);
            writer.setSelection(InsertEmoji, 'on');
        });
    }

    refresh() {
        this.isEnabled = true;
    }
}

